import React from "react";
import Link from "../../utils/link";
import FluidImage from "../fluidImage";
import Video from "../video";
import ResVideo from "../resVideo";
import ResImg from "../resImg";

const WorkCard = (props) => {

    const block = props.block


    const hasVideo = block.video?.filename != undefined

    const blackText = block.black_text

    return (
        <li className={`group ${block.full_width ? `lg:col-span-2` : `col-span-1`} relative ${block.hide_on_mobile ? `hidden lg:block` : ``} homepage-card`}>
            <div className={`relative aspect-[355/440] ${block.full_width ? `lg:aspect-[8/3]` : `lg:aspect-[4/3]`} overflow-hidden`}>
                <div className="absolute inset-0 w-full h-full group-hover:scale-105 duration-1000 transition-transform hidden lg:block">
                    <FluidImage image={block.hover_image} />
                </div>
                <div className="w-full h-full group-hover:lg:opacity-0 transition-opacity duration-1000">
                    {
                        hasVideo ? (
                            <ResVideo desktopVideo={block.video} mobileVideo={block.mobile_video} desktopPoster={block.image} mobilePoster={block.mobile_image} className='w-full h-full isolate object-cover' />
                        ) : (
                            <ResImg desktop={block.image} mobile={block.mobile_image} className='w-full h-full isolate object-cover' />
                        )
                    }
                </div>

            </div>

            <div className={`lg:absolute left-0 pt-4 lg:pt-0 bottom-0 z-[5] pointer-events-none text-black ${blackText ? `lg:text-black` : `lg:text-white`} flex lg:px-7 lg:py-4 w-full text-xs lg:text-base justify-between lg:justify-start lg:opacity-0 lg:group-hover:opacity-100 transition-opacity duration-300`}>


                {block.title != "" && (<h3 className="font-semibold lg:w-[7.625rem] title">
                    {block.title}
                </h3>
                )}

                {block.copy != "" && (

                    <p className="copy">
                        {block.copy}
                    </p>
                )}

            </div>

            <Link className='absolute inset-0 w-full h-full z-10' to={block.link.cached_url}>
                <span className="sr-only">{`Read ${block.title}`}</span>
            </Link>
        </li>
    )
}

export default WorkCard